import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, CircularProgress, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

const exportButtonSx = {
  height: 46,
  minWidth: { xs: '100%', sm: 148 },
  px: 2.5,
  fontWeight: 600,
  textTransform: 'none' as const,
  bgcolor: '#226AAA',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#1a5588', boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: '#94a3b8' }
};

export const IssuesExportMenu = ({
  onExportCsv,
  onExportXlsx,
  disabled,
  loading,
  label = 'Export CSV'
}: {
  onExportCsv?: () => void | Promise<void>;
  onExportXlsx?: () => void | Promise<void>;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
}) => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(anchor);
  const isBusy = disabled || loading;

  const hasCsv = !!onExportCsv;
  const hasXlsx = !!onExportXlsx;
  if (!hasCsv && !hasXlsx) return null;

  const startIcon = isBusy ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    <FileDownloadOutlinedIcon fontSize="small" />
  );

  if (hasCsv && !hasXlsx) {
    return (
      <Button
        variant="contained"
        disabled={isBusy}
        startIcon={startIcon}
        sx={exportButtonSx}
        onClick={() => void onExportCsv?.()}>
        {label}
      </Button>
    );
  }

  return (
    <>
      <Button
        variant="contained"
        disabled={isBusy}
        startIcon={startIcon}
        sx={exportButtonSx}
        onClick={(e) => setAnchor(e.currentTarget)}>
        Export
      </Button>
      <Menu anchorEl={anchor} open={open} onClose={() => setAnchor(null)}>
        {hasCsv ? (
          <MenuItem
            onClick={() => {
              setAnchor(null);
              void onExportCsv?.();
            }}>
            Export CSV (current filters)
          </MenuItem>
        ) : null}
        {hasXlsx ? (
          <MenuItem
            onClick={() => {
              setAnchor(null);
              void onExportXlsx?.();
            }}>
            Export Excel (background job)
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};
